import { PipelineStep, NavigationInstruction, Next, Redirect } from 'aurelia-router';
import { trace,Span } from '@opentelemetry/api';

function getElementXPath(element) {
    if (element.id !== '') {
        return 'id("' + element.id + '")';
    }
    if (element === document.body) {
        return element.tagName;
    }
    var ix = 0;
    var siblings = element.parentNode.childNodes;
    for (var i = 0; i < siblings.length; i++) {
        var sibling = siblings[i];
        if (sibling === element) {
            return getElementXPath(element.parentNode) + '/' + element.tagName + '[' + (ix + 1) + ']';
        }
        if (sibling.nodeType === 1 && sibling.tagName === element.tagName) {
            ix++;
        }
    }
}
export class OtelNavigationInstrumentation implements PipelineStep {
    async run(instruction: NavigationInstruction, next: Next): Promise<any> {
        const tracer = trace.getTracer('Aurelia');
        return tracer.startActiveSpan(`Navigate to ${instruction.config.name}`, async (span: Span) => {
            const result = await next();
            span.end();
            return result;
        });
    }
}